import React, { useEffect, useState } from 'react';
import { useFormik } from 'formik';
import { notification } from 'antd';
import axiosInstance from '../../../../Services/axiosCommon';
import { NuInput, NuInputSetting } from '../../../../Components/Utils/Input';
import { GetAccess } from '../../../../Components/Utils/roles';
import { TextMediumXS } from '../../../../Components/Text/MediumText';

function Equip() {
  const [data, setData] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [allSelectedUserIds, setAllSelectedUserIds] = useState(new Set());
  const [selectedFile, setSelectedFile] = useState(null);
  const [api, contextHolder] = notification.useNotification();

  const formik = useFormik({
    initialValues: {
      name: ''
    },
    onSubmit: (values, { resetForm }) => {
      const formData = new FormData();
      formData.append('json_data', JSON.stringify(values));
      
      if (selectedFile) {
        formData.append('equipmentImage', selectedFile);
      }

      axiosInstance
        .post('/equipments/new-equipment', formData)
        .then((res) => {
          if (res.status === 201 || res.data?.status) {
            GetData();
            resetForm();
            setSelectedFile(null);
            api.success({
              message: 'Equipment Creation Successful',
              description: res?.data?.msg || 'Added to the Equipment list',
              placement: 'bottomRight',
            });
          } else {
            api.error({
              message: 'Equipment Creation Failed',
              description: res?.data?.msg || 'Network error',
              placement: 'bottomRight',
            });
          }
        })
        .catch((err) => {
          api.error({
            message: 'Equipment Creation Failed',
            description: err?.response?.data?.msg || 'Server error or Network error',
            placement: 'bottomRight',
          });
        });
    },
  });

  const GetData = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get('/equipments/list');
      let inspectorList = response.data?.data?.data || [];

      inspectorList.sort((a, b) => {
        const nameA = a.userName?.toLowerCase() || '';
        const nameB = b.userName?.toLowerCase() || '';
        return nameA.localeCompare(nameB);
      });

      const currentIds = new Set(inspectorList.map(inspector => inspector.userId));
      setAllSelectedUserIds(currentIds);
      setData(inspectorList);
    } catch (error) {
      api.error({
        message: 'Failed to Fetch Equipment',
        description: error?.response?.data?.msg || 'Network error',
        placement: 'bottomRight',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      setLoading(true);
      const response = await axiosInstance.delete(`/equipments/${id}`);
      if (response.status === 200) {
        api.success({
          message: 'Equipment deleted successfully',
          placement: 'bottomRight',
        });
        GetData();
      }
    } catch (error) {
      api.error({
        message: 'Failed to Delete Equipment',
        description: error?.response?.data?.msg || 'Network error',
        placement: 'bottomRight',
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div className='w-full px-3 mt-2'>
      {contextHolder}
      <form onSubmit={formik.handleSubmit}>
         <div className="w-full text-xs">
          <div className="px-3 mb-1">
             <label className="font-medium text-textColor-500 mb-1 text-xs">
              {'Name'}
            </label>
            <NuInputSetting
              label='Name'
              placeholder='Name'
              formik={formik}
              name='name'
              width='w-full'
              new_width='w-full'
            />
          </div>
          {/* {GetAccess('equipment_create') && (
            <div className='mt-6'>
              <button
                type='submit'
                className='bg-baseColor-primary text-white rounded-md px-3 py-2 hover:bg-green-800 transition-colors focus:outline-none text-xs'
                disabled={loading}
              >
                Add
              </button>
            </div>
          )} */}
        </div>
      </form>

<div className="flex justify-start">
  <div className="w-[96%] rounded-lg ml-2.5 h-44 bg-[#f5f3ff] border border-gray-300 overflow-x-hidden overflow-y-auto">
    {data.length === 0 ? (
      <div className="flex items-center justify-center h-full text-gray-500 text-xs">
        No Equipment added yet
      </div>
    ) : (
      <ul>
        {data.map((item, idx) => (
          <li
            className="m-1 flex justify-between items-center text-xs bg-white border border-gray-300 rounded text-main-title py-2 px-2 hover:bg-[#B3EBD7] hover:bg-opacity-50"
            key={item.id || idx}
          >
            <TextMediumXS
              color="text-[#697565]"
              content={item.name || 'No name'}
            />
            {GetAccess('equipment_delete') && !item?.isDefault && (
              <span
                onClick={() => handleDelete(item.id)}
                className="text-blue-900 cursor-pointer hover:text-red-600"
              >
                ×
              </span>
            )}
          </li>
        ))}
      </ul>
    )}
  </div>
</div>

    </div>
  );
}

export default Equip;